import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["allowList", "defaultItemIndex", "defaultItem", "filterType", "trackingKey", "filterClearingValue", "retainSelection", "onFilterChange"];
import { useCallback } from 'react';
import I18n from 'I18n';
import { ACADEMY_SUPPORTED_LANGUAGES } from '../../../constants/academySupportedLanguages';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { useMediaQuery } from '../../../utils/Styling';
import { useFilterOptions } from '../filtersHooks';
// @ts-ignore Could not find a declaration file for module
import { useSearchParamInput } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
export const RouterSelectSingle = _ref => {
  let {
      allowList,
      defaultItemIndex = 0,
      defaultItem,
      filterType,
      trackingKey = filterType,
      filterClearingValue,
      retainSelection = true,
      onFilterChange
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isDesktop
  } = useMediaQuery();
  const options = useFilterOptions(filterType);
  const [paramValue, setSearchParamInput] = useSearchParamInput(filterType, true);
  const defaultValue = defaultItem || options[defaultItemIndex];
  let selected;
  if (filterType === 'language' && typeof paramValue[0] === 'string') {
    // language values need to be in uppercase
    const lang = paramValue[0].toUpperCase();
    selected = ACADEMY_SUPPORTED_LANGUAGES.includes(lang) ? lang : 'EN';
  } else {
    selected = paramValue[0] || defaultValue;
  }
  const onOpen = useCallback(({
    currentTarget
  }) => {
    const {
      value
    } = currentTarget;
    if (value) {
      UsageTracker.trackStandalone('Filter Interaction', {
        action: 'filter-menu-opened',
        key: trackingKey,
        value: selected
      });
    }
  }, [selected, trackingKey]);
  const changeHandler = useCallback(changeEvent => {
    const {
      currentTarget: {
        value
      }
    } = changeEvent;
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-selected',
      value,
      key: trackingKey,
      defaultValue
    });
    if (onFilterChange) return onFilterChange(value);
    if (filterClearingValue && filterClearingValue === value.toLowerCase()) {
      setSearchParamInput({
        target: {
          value: ''
        }
      });
    } else {
      setSearchParamInput(changeEvent);
    }
  }, [onFilterChange, filterClearingValue, trackingKey, defaultValue, setSearchParamInput]);
  return /*#__PURE__*/_jsx(Select, Object.assign({
    buttonUse: "transparent",
    "data-test-id": `filter-type-${filterType}`,
    onChange: changeHandler,
    onOpenChange: onOpen,
    options: options.map(option => ({
      disabled: !!allowList && !allowList.map(allowItem => allowItem.toLowerCase()).includes(option.toLowerCase()),
      text: filterType === 'language' ? isDesktop ? LanguageNames[option.toLowerCase()] : option.toLowerCase() : I18n.text(`academyComponents.topFilters.${filterType}.${option}`),
      value: option
    })),
    value: retainSelection ? selected : null
  }, props));
};